import { render, staticRenderFns } from "./LuExciseTaxRatesGrid.vue?vue&type=template&id=efc197d0&"
import script from "./LuExciseTaxRatesGrid.vue?vue&type=script&lang=js&"
export * from "./LuExciseTaxRatesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports